import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography
} from "@mui/material";
import type { FC } from "react";

type Props = {
  message: string;
};

export const ConfigurationError: FC<Props> = ({ message }) => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4
      }}
    >
      <Card
        elevation={8}
        sx={{
          width: "100%",
          maxWidth: 760,
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(247,250,252,0.98) 100%)"
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={2.5}>
            <Chip
              icon={<ConstructionOutlinedIcon />}
              label="Setup required"
              color="secondary"
              sx={{ alignSelf: "flex-start" }}
            />
            <Typography variant="h4" component="h1">
              Compliance Hub is ready for wiring, but not configured yet
            </Typography>
            <Typography variant="body1" color="text.secondary">
              The shell, routing, and runtime bootstrap are in place. Finish the
              deploy-time configuration so sign-in can start normally.
            </Typography>
            <Alert severity="warning">{message}</Alert>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Next step
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Replace the placeholder values in <code>/public/config.js</code>
                {" "}or provide the same keys through your deployment rewrite
                flow, then reload the app.
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};
